/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card } from 'antd';
import 'antd/dist/antd.css';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ReactComponent as EnglandFlag } from '../../assets/flags/england.svg';
import { ReactComponent as GermanyFlag } from '../../assets/flags/germany.svg';
import { ReactComponent as ItalyFlag } from '../../assets/flags/italy.svg';
import { ReactComponent as PolnadFlag } from '../../assets/flags/poland.svg';
import { ReactComponent as FranceFlag } from '../../assets/flags/france.svg';
import CreateAccountHeader from '../CreateAccountHeader';
import { InviteHeader } from '../Forms';

const Country = styled.p`

font-family: 'Roboto';
font-style: normal;
font-weight: 300;
font-size: 16px;
line-height: 22px;

/* identical to box height, or 138% */

/* Gray 1 */
color: #333333;

/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;
margin: 0px 20px;
`;

const EuInvitation = ({ companyName, setStep, regionFormConfig }) => {
  const { t, i18n } = useTranslation();

  const onClick = (language) => {
    i18n.changeLanguage(language).then(() => setStep());
  };

  return (
    <>
      <CreateAccountHeader
        company={companyName}
        descLabel={t(`FORM_USER_ACCOUNT.USER_ACCOUNT_DESC_${regionFormConfig.code}`)}
        regionFormConfig={regionFormConfig}
        detail={false}
      />
      <Row align="middle" justify="center" gutter={32} style={{ marginTop: '15px', marginBottom: '35px' }}>
        <Col span={2} />
        <Col span={20}>
          <div className="site-card-border-less-wrapper">
            <Row align="middle" type="flex">
              <Col style={{ marginBottom: '20px' }} span={24}>
                <InviteHeader>{t('FORM_USER_ACCOUNT.LANGUAGE_SELECTION')}</InviteHeader>
              </Col>
            </Row>
            <Row align="middle" justify="center">
              <Card
                onClick={() => onClick('en')}
                style={{
                  width: 438,
                  height: 56,
                  border: '1px solid #D9D9D9',
                  borderRadius: '2px',
                  boxShadow: '0px 1px 5px rgba(51, 51, 51, 0.1)',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <Row align="middle" justify="center">
                  <Col span={1}>
                    <EnglandFlag style={{ marginTop: '-5px' }} />
                  </Col>
                  <Col span={23} style={{ marginTop: '-10px' }}>
                    <Country>
                      {t('LANGUAGE.ENGLAND')}
                    </Country>
                  </Col>
                </Row>
              </Card>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: '30px' }}>
              <Card
                onClick={() => onClick('de')}
                style={{
                  width: 438,
                  height: 56,
                  border: '1px solid #D9D9D9',
                  borderRadius: '2px',
                  boxShadow: '0px 1px 5px rgba(51, 51, 51, 0.1)',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <Row align="middle" justify="center">
                  <Col span={1} style={{ marginTop: '-5px' }}>
                    <GermanyFlag />
                  </Col>
                  <Col span={23} style={{ marginTop: '-10px' }}>
                    <Country>
                      {t('LANGUAGE.GERMANY')}
                    </Country>
                  </Col>
                </Row>
              </Card>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: '30px' }}>
              <Card
                onClick={() => onClick('pl')}
                style={{
                  width: 438,
                  height: 56,
                  border: '1px solid #D9D9D9',
                  borderRadius: '2px',
                  boxShadow: '0px 1px 5px rgba(51, 51, 51, 0.1)',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <Row align="middle" justify="center">
                  <Col span={1} style={{ marginTop: '-5px' }}>
                    <PolnadFlag />
                  </Col>
                  <Col span={23} style={{ marginTop: '-10px' }}>
                    <Country>
                      {t('LANGUAGE.POLAND')}
                    </Country>
                  </Col>
                </Row>
              </Card>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: '30px' }}>
              <Card
                onClick={() => onClick('it')}
                style={{
                  width: 438,
                  height: 56,
                  border: '1px solid #D9D9D9',
                  borderRadius: '2px',
                  boxShadow: '0px 1px 5px rgba(51, 51, 51, 0.1)',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <Row align="middle" justify="center">
                  <Col span={1} style={{ marginTop: '-5px' }}>
                    <ItalyFlag />
                  </Col>
                  <Col span={23} style={{ marginTop: '-10px' }}>
                    <Country>
                      {t('LANGUAGE.ITALY')}
                    </Country>
                  </Col>
                </Row>
              </Card>
            </Row>
            <Row align="middle" justify="center" style={{ marginTop: '30px' }}>
              <Card
                onClick={() => onClick('fr')}
                style={{
                  width: 438,
                  height: 56,
                  border: '1px solid #D9D9D9',
                  borderRadius: '2px',
                  boxShadow: '0px 1px 5px rgba(51, 51, 51, 0.1)',
                  boxSizing: 'border-box',
                  cursor: 'pointer',
                }}
              >
                <Row align="middle" justify="center">
                  <Col span={1} style={{ marginTop: '-5px' }}>
                    <FranceFlag />
                  </Col>
                  <Col span={23} style={{ marginTop: '-10px' }}>
                    <Country>
                      {t('LANGUAGE.FRANCE')}
                    </Country>
                  </Col>
                </Row>
              </Card>
            </Row>
          </div>

        </Col>
        <Col span={2} />
      </Row>
    </>
  );
};

EuInvitation.propTypes = {
  companyName: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  regionFormConfig: PropTypes.any.isRequired,
};

export default EuInvitation;
